import wpAjax from './axios';

/**
 * Generate event IDs
 */
function capiGetEventID() {
	var result = [];
	var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	var charactersLength = characters.length;
	for (var i = 0; i < 23; i++) {
		result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
	}
	return result.join('');
}

/**
 * Get fb cookie values
 */
function capiGetCookie(name) {
	var nameEQ = name + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

/**
 * AJAX setup to send a basic event
 *
 * Used for misc click events, form submits, etc where
 * it's not needed to pass any data other than the event name.
 */
async function capiBasicEventAjax(eventName) {
	// Send Pixel event
	const eventID = capiGetEventID();
	// if (fbq) fbq('track', eventName, {}, { eventID: eventID });

	// Send CAPI event
	const { data } = await wpAjax.post('', {
		event_name: eventName,
		event_source: window.location.href,
		event_id: eventID,
		fbp: capiGetCookie('_fbp'),
		fbc: capiGetCookie('_fbc'),
		action: 'send_basic_event',
	});

	console.log(data);
}

export { capiBasicEventAjax, capiGetCookie, capiGetEventID };
